import MenuSyncMode from './MenuSyncMode.enum';

/**
 * The sync choices the user makes in the Sync With POS modal. Mirrors ISyncOptions in @ready/menusync.
 */
export default interface MenuSyncOptions {
  mode: MenuSyncMode;
  /**
   * Whether a full import also adds what it created to the company's Shared Menu Items. Only meaningful
   * when mode is FULL — an availability sync creates nothing to promote.
   */
  promoteToTemplates: boolean;
}

export const defaultMenuSyncOptions: MenuSyncOptions = {
  mode: MenuSyncMode.FULL,
  promoteToTemplates: true,
};
